import Irmao, { LojaIrmao } from "../types/Irmao"
import { IUser } from "../types/User"
import { containsAny } from "./utils"

export const usuarioPertenceALoja = (user: IUser | null, idLoja: string | null) =>
	!!user &&
	user.role !== 'Visitante' &&
	(user.loja._id === idLoja || user.lojas.some(loja => loja.loja._id === idLoja))
	
export const usuarioPertenceALojaAtivo = (user: IUser | null, idLoja: string | null) =>
	user?.role !== 'Visitante' &&
	irmaoPertenceALojaAtivo(user, idLoja)

export function irmaoPertenceALojaAtivo(irmao: Pick<Irmao, 'loja' | 'situacaoDoMacon' | 'lojas'> | null, idLoja: string | null) {
	return !!irmao &&
		(
			éAtivoEmLoja(irmao, irmao.loja, idLoja) ||
			irmao.lojas.some(loja => éAtivoEmLoja(loja, loja.loja, idLoja))
		)
}

export function éCargoDaLojaAtivo(irmao: Pick<Irmao, 'loja' | 'situacaoDoMacon' | 'lojas' | 'cargoDeAdminDaLoja'> | null, cargos: string[], idLoja: string | null) {
	return !!irmao &&
		(
			(éAtivoEmLoja(irmao, irmao.loja, idLoja) && irmao.cargoDeAdminDaLoja && containsAny(irmao.cargoDeAdminDaLoja, cargos)) ||
			irmao.lojas.some(loja => éAtivoEmLoja(loja, loja.loja, idLoja) && loja.cargoDeAdminDaLoja && containsAny(loja.cargoDeAdminDaLoja, cargos))
		)
}

export function éAtivoEmLoja(irmao: Omit<LojaIrmao, 'tipo'>, loja: { _id: { toString: () => string } }, idLoja: { toString: () => string } | null) {
	return irmao.situacaoDoMacon === 'Regular' && loja._id.toString() === idLoja?.toString()
}

